import Vue from 'vue';
import App from './App';
import LazyImage from './components/image/';
import './style.scss';

Vue.component('lazy-image', LazyImage);
new Vue({
  el: '#root',
  render: h => h(App),
});
